import { useState, useMemo } from "react";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { SearchMonthSingleForm } from "src/components/common/form/search/SearchMonthSingleForm";
import { useTQC2070_R01Store } from "./Store_TQC2070_R01";

// Props 타입 정의: 엔터키 핸들러, PDF 다운로드 핸들러
interface Props {
	onEnterKeyDown: () => void;
	onPdfZincClick: () => void;
	onPdfNaohClick: () => void;
}

export const SearchSection_TQC2070_R01 = (props: Props) => {
	const { onEnterKeyDown, onPdfZincClick, onPdfNaohClick } = props;

	const { TQC2070_R01Filter, setTQC2070_R01Filter } = useTQC2070_R01Store();
	const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });

	// searchAnalysisDt를 Date로 변환 (yyyy-MM 형식)
	const analysisDtDate = useMemo(() => {
		if (!TQC2070_R01Filter.searchAnalysisDt) return undefined;
		const [year, month] = TQC2070_R01Filter.searchAnalysisDt.split('-').map(Number);
		if (year && month) {
			return new Date(year, month - 1, 1);
		}
		return undefined;
	}, [TQC2070_R01Filter.searchAnalysisDt]);

	// Date를 yyyy-MM 형식으로 변환하여 필터에 설정
	const handleAnalysisDtChange = (date: Date | undefined) => {
		if (date) {
			const year = date.getFullYear();
			const month = String(date.getMonth() + 1).padStart(2, '0');
			setTQC2070_R01Filter({ searchAnalysisDt: `${year}-${month}` });
		} else {
			setTQC2070_R01Filter({ searchAnalysisDt: '' });
		}
	};

	return (
		<div className="w-full">
			<SearchSectionForm>
				<SearchMonthSingleForm
					label="분석일자"
					visible={pickerVisible}
					setVisible={setPickerVisible}
					value={analysisDtDate}
					onChange={handleAnalysisDtChange}
					pickerPosition={pickerPosition}
					setPickerPosition={setPickerPosition}
				/>
				
				{/* PDF 다운로드 버튼 영역 */}
				<div className="flex items-center gap-2 ml-auto">
					<button
						type="button"
						onClick={onPdfZincClick}
						className="px-4 py-1.5 bg-blue-500 text-white text-sm font-medium rounded hover:bg-blue-600 transition-colors"
						title="아연액 분석 보고서 PDF 다운로드"
					>
						아연액 보고서
					</button>
					<button
						type="button"
						onClick={onPdfNaohClick}
						className="px-4 py-1.5 bg-green-500 text-white text-sm font-medium rounded hover:bg-green-600 transition-colors"
						title="가성소다액 분석 보고서 PDF 다운로드"
					>
						가성소다액 보고서
					</button>
				</div>
			</SearchSectionForm>
		</div>
	);
};

export default SearchSection_TQC2070_R01;

